module.exports = __webpack_public_path__ + "media/images/cms/img_slide_11-6e77f9a5bc0a6a0bbc68ac1bdf31851c.jpg";